<template>
  <div class="openapi-page" v-loading.fullscreen.lock="state.fullLoading">
    <el-card>
      <template #header>
        <div class="page-header"><span>开放产品与授权</span></div>
      </template>

      <el-tabs v-model="state.activeTab" @tab-change="handleTabChange">
        <el-tab-pane label="产品目录" name="product">
          <div class="toolbar">
            <el-select v-model="productSearch.productCode" filterable clearable placeholder="产品编码">
              <el-option v-for="item in productTemplates" :key="item.productCode" :label="item.productName + ' / ' + item.productCode" :value="item.productCode" />
            </el-select>
            <el-select v-model="productSearch.status" clearable placeholder="状态">
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
            <el-button type="primary" @click="loadProducts">查询</el-button>
            <el-button @click="openProductDialog()">新增产品</el-button>
          </div>

          <el-table :data="products" border height="calc(100vh - 350px)" v-loading="state.tableLoading">
            <el-table-column prop="productCode" label="产品编码" min-width="160" />
            <el-table-column prop="productName" label="产品名称" min-width="160" />
            <el-table-column prop="productType" label="产品类型" min-width="120" />
            <el-table-column label="接口编码" min-width="190">
              <template #default="scope">{{ scope.row.interfaceCode || scope.row.invokeCode || "-" }}</template>
            </el-table-column>
            <el-table-column prop="callbackMode" label="回调模式" width="110"><template #default="scope">{{ scope.row.callbackMode ? '是' : '否' }}</template></el-table-column>
            <el-table-column label="默认售价" width="110"><template #default="scope">{{ yuan(scope.row.defaultPrice) }}</template></el-table-column>
            <el-table-column label="默认成本" width="110"><template #default="scope">{{ yuan(scope.row.defaultCostPrice) }}</template></el-table-column>
            <el-table-column prop="status" label="状态" width="90">
              <template #default="scope"><el-tag :type="scope.row.status === 'ENABLED' ? 'success' : 'info'">{{ scope.row.status === 'ENABLED' ? '启用' : '停用' }}</el-tag></template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150"><template #default="scope"><el-button size="small" @click="openProductDialog(scope.row)">编辑</el-button><el-button size="small" type="danger" @click="removeProduct(scope.row)">删除</el-button></template></el-table-column>
          </el-table>
          <div class="pagination-box"><el-pagination background layout="total, sizes, prev, pager, next" v-model:current-page="productPage.current" v-model:page-size="productPage.size" :total="productPage.total" :page-sizes="productPage.sizes" @current-change="loadProducts" @size-change="loadProducts" /></div>
        </el-tab-pane>

        <el-tab-pane label="应用授权" name="auth">
          <div class="toolbar">
            <el-input v-model="authSearch.appKey" clearable placeholder="AppKey" @keyup.enter="loadAuths" />
            <el-input v-model="authSearch.merchantId" clearable placeholder="商户ID" @keyup.enter="loadAuths" />
            <el-select v-model="authSearch.productCode" filterable clearable placeholder="产品编码">
              <el-option v-for="item in authProductOptions" :key="item.productCode" :label="item.productName + ' / ' + item.productCode" :value="item.productCode" />
            </el-select>
            <el-select v-model="authSearch.status" clearable placeholder="状态">
              <el-option label="启用" value="ENABLED" />
              <el-option label="停用" value="DISABLED" />
            </el-select>
            <el-button type="primary" @click="loadAuths">查询</el-button>
            <el-button @click="openAuthDialog()">新增授权</el-button>
          </div>

          <el-table :data="auths" border height="calc(100vh - 350px)" v-loading="state.tableLoading">
            <el-table-column prop="appId" label="应用 ID" min-width="150" />
            <el-table-column prop="merchantId" label="商户ID" min-width="150" />
            <el-table-column prop="productCode" label="产品编码" min-width="170" />
            <el-table-column label="内部产品" min-width="240" show-overflow-tooltip>
              <template #default="scope">{{ internalProductText(scope.row.internalProductId) }}</template>
            </el-table-column>
            <el-table-column label="销售价" width="100"><template #default="scope">{{ yuan(scope.row.salePrice) }}</template></el-table-column>
            <el-table-column label="成本价" width="100"><template #default="scope">{{ yuan(scope.row.costPrice) }}</template></el-table-column>
            <el-table-column prop="dailyLimit" label="日限额" width="90" />
            <el-table-column prop="monthlyLimit" label="月限额" width="90" />
            <el-table-column prop="testLimit" label="试用次数" width="100" />
            <el-table-column prop="testUsedCount" label="已用试用" width="100" />
            <el-table-column prop="callbackEnabled" label="返回报告地址" width="120"><template #default="scope">{{ isCallbackProduct(scope.row.productCode) ? '必须返回' : (Number(scope.row.callbackEnabled) === 1 ? '是' : '否') }}</template></el-table-column>
            <el-table-column prop="callbackUrl" label="下游回调地址" min-width="220" show-overflow-tooltip />
            <el-table-column prop="status" label="状态" width="90"><template #default="scope"><el-tag :type="scope.row.status === 'ENABLED' ? 'success' : 'info'">{{ scope.row.status === 'ENABLED' ? '启用' : '停用' }}</el-tag></template></el-table-column>
            <el-table-column fixed="right" label="操作" width="150"><template #default="scope"><el-button size="small" @click="openAuthDialog(scope.row)">编辑</el-button><el-button size="small" type="danger" @click="removeAuth(scope.row)">删除</el-button></template></el-table-column>
          </el-table>
          <div class="pagination-box"><el-pagination background layout="total, sizes, prev, pager, next" v-model:current-page="authPage.current" v-model:page-size="authPage.size" :total="authPage.total" :page-sizes="authPage.sizes" @current-change="loadAuths" @size-change="loadAuths" /></div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog v-model="productDialog.visible" :title="productDialog.form.id ? '编辑产品' : '新增产品'" width="560px">
      <el-form :model="productDialog.form" label-width="100px">
        <el-form-item label="产品编码"><el-select v-model="productDialog.form.productCode" filterable allow-create default-first-option placeholder="请选择产品" style="width: 100%" @change="applyProductTemplate"><el-option v-for="item in productTemplates" :key="item.productCode" :label="item.productName + ' / ' + item.productCode" :value="item.productCode" /></el-select></el-form-item>
        <el-form-item label="产品名称"><el-input v-model="productDialog.form.productName" /></el-form-item>
        <el-form-item label="产品类型"><el-input v-model="productDialog.form.productType" placeholder="ACCIDENT / MAINTENANCE 等" /></el-form-item>
        <el-form-item label="接口编码"><el-input v-model="productDialog.form.interfaceCode" placeholder="例如 ACCIDENT_CHENGHAO" /></el-form-item>
        <el-form-item label="回调模式"><el-switch v-model="productDialog.form.callbackMode" :active-value="1" :inactive-value="0" /><div class="form-tip">开启后表示该产品结果由第三方回调完成，例如成浩出险。</div></el-form-item>
        <el-form-item label="默认售价"><el-input-number v-model="productDialog.form.defaultPriceYuan" :precision="2" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="默认成本"><el-input-number v-model="productDialog.form.defaultCostPriceYuan" :precision="2" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="productDialog.form.status"><el-radio label="ENABLED">启用</el-radio><el-radio label="DISABLED">停用</el-radio></el-radio-group></el-form-item>
        <el-form-item label="备注"><el-input v-model="productDialog.form.remark" type="textarea" /></el-form-item>
      </el-form>
      <template #footer><el-button @click="productDialog.visible = false">取消</el-button><el-button type="primary" @click="saveProduct">保存</el-button></template>
    </el-dialog>

    <el-dialog v-model="authDialog.visible" :title="authDialog.form.id ? '编辑授权' : '新增授权'" width="620px">
      <el-form :model="authDialog.form" label-width="120px">
        <el-form-item label="应用"><el-select v-model="authDialog.form.appId" filterable placeholder="请选择应用" style="width: 100%" @change="applyAuthApp"><el-option v-for="item in appOptions" :key="item.id" :label="item.appName + ' / 测试：' + (item.testAppKey || item.appKey || '-') + ' / 生产：' + (item.prodAppKey || '-')" :value="item.id" /></el-select></el-form-item>
        <el-form-item label="商户ID"><el-input v-model="authDialog.form.merchantId" disabled placeholder="选择应用后自动带出" /></el-form-item>
        <el-form-item label="产品编码"><el-select v-model="authDialog.form.productCode" filterable placeholder="请选择产品" style="width: 100%" @change="applyAuthProduct"><el-option v-for="item in authProductOptions" :key="item.productCode" :label="item.productName + ' / ' + item.productCode" :value="item.productCode" /></el-select></el-form-item>
        <el-form-item label="内部产品">
          <el-select v-model="authDialog.form.internalProductId" filterable clearable placeholder="请选择内部产品" style="width: 100%">
            <el-option v-for="item in filteredInternalProducts" :key="item.productId" :label="formatInternalProduct(item)" :value="String(item.productId)" />
          </el-select>
        </el-form-item>
        <el-form-item label="销售价"><el-input-number v-model="authDialog.form.salePriceYuan" :precision="2" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="成本价"><el-input-number v-model="authDialog.form.costPriceYuan" :precision="2" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="日调用上限"><el-input-number v-model="authDialog.form.dailyLimit" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="月调用上限"><el-input-number v-model="authDialog.form.monthlyLimit" :min="0" :controls="false" style="width: 100%" /></el-form-item>
        <el-form-item label="试用次数"><el-input-number v-model="authDialog.form.testLimit" :min="0" :controls="false" style="width: 100%" /><div class="form-tip">0 表示不限</div></el-form-item>
        <el-form-item label="已用试用次数"><el-input-number v-model="authDialog.form.testUsedCount" :min="0" :controls="false" disabled style="width: 100%" /></el-form-item>
        <el-form-item label="返回报告地址">
          <span v-if="isCallbackProduct(authDialog.form.productCode)">必须返回（回调模式产品）</span>
          <template v-else>
            <el-switch v-model="authDialog.form.callbackEnabled" :active-value="1" :inactive-value="0" />
            <div class="form-tip">控制下游是否收到有效报告地址；内部报告和图片仍会留存，图片不对外返回。</div>
          </template>
        </el-form-item>
        <el-form-item label="下游回调地址"><el-input v-model="authDialog.form.callbackUrl" placeholder="回调模式产品可配置下游接收地址" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="authDialog.form.status"><el-radio label="ENABLED">启用</el-radio><el-radio label="DISABLED">停用</el-radio></el-radio-group></el-form-item>
      </el-form>
      <template #footer><el-button @click="authDialog.visible = false">取消</el-button><el-button type="primary" @click="saveAuth">保存</el-button></template>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { getDictItemPageFun } from "@/api/dict";
import { getProductListFun } from "@/api/product";
import { getOpenApiAppPage, getOpenApiProductPage, saveOpenApiProduct, deleteOpenApiProduct, getOpenApiAppProductPage, saveOpenApiAppProduct, deleteOpenApiAppProduct } from "@/api/openapi";

const PRODUCT_TEMPLATE_DICT = "OPEN_API_PRODUCT_TEMPLATE";
const PRODUCT_VENDOR_MAP = {
  LEMON_ACCIDENT: "XYL",
  "50002": "CXM_NON_DAMAGE",
  "50001": "CHENGHAO",
  "50003": "SANCAI_BRIEF",
  "60001": "MILEAGE_CHAIN",
};
const OPTIONAL_INTERNAL_PRODUCT_CODES = new Set(["50001", "60001"]);

const state = reactive({ activeTab: "product", tableLoading: false, fullLoading: false });
const productSearch = reactive({ productCode: "", status: "" });
const authSearch = reactive({ appKey: "", merchantId: "", productCode: "", status: "" });
const products = ref([]);
const auths = ref([]);
const productTemplates = ref([]);
const appOptions = ref([]);
const authProductOptions = ref([]);
const internalProducts = ref([]);
const productPage = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const authPage = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const productDialog = reactive({ visible: false, form: {} });
const authDialog = reactive({ visible: false, form: {} });

const filteredInternalProducts = computed(() => {
  const vendor = expectedVendor(authDialog.form.productCode);
  if (!vendor) return internalProducts.value;
  return internalProducts.value.filter((item) => normalizeCode(item.thirdPartyName) === vendor);
});

const yuan = (cent) => cent === null || cent === undefined ? "-" : `￥${(cent / 100).toFixed(2)}`;
const cent = (yuanValue) => Math.round((Number(yuanValue) || 0) * 100);

function normalizeCode(value) {
  return String(value || "").trim().toUpperCase();
}

function expectedVendor(productCode) {
  return PRODUCT_VENDOR_MAP[normalizeCode(productCode)] || "";
}

function isCallbackProduct(productCode) {
  const product = authProductOptions.value.find((item) => normalizeCode(item.productCode) === normalizeCode(productCode));
  return Number(product?.callbackMode) === 1;
}

function formatInternalProduct(item = {}) {
  const name = item.description || item.name || "未命名产品";
  const vendor = item.thirdPartyDisplayName || item.thirdPartyName || "未配置厂商";
  return `${name} / ${vendor} / ${item.productId}`;
}

function internalProductText(productId) {
  if (!productId) return "-";
  const item = internalProducts.value.find((product) => String(product.productId) === String(productId));
  return item ? formatInternalProduct(item) : String(productId);
}

function loadProducts() {
  state.tableLoading = true;
  getOpenApiProductPage({ ...productSearch, current: productPage.current, size: productPage.size })
    .then((res) => { products.value = res.data.records || []; productPage.total = res.data.total || 0; })
    .finally(() => state.tableLoading = false);
}

function loadAuths() {
  state.tableLoading = true;
  getOpenApiAppProductPage({ ...authSearch, current: authPage.current, size: authPage.size })
    .then((res) => { auths.value = res.data.records || []; authPage.total = res.data.total || 0; })
    .finally(() => state.tableLoading = false);
}

function handleTabChange() {
  if (state.activeTab === "product") {
    loadProducts();
    return;
  }
  loadAuthProductOptions();
  loadInternalProductOptions();
  loadAuths();
}

function openProductDialog(row) {
  loadProductTemplates();
  productDialog.form = row
    ? { ...row, interfaceCode: row.interfaceCode || row.invokeCode || "", callbackMode: row.callbackMode || 0, defaultPriceYuan: (row.defaultPrice || 0) / 100, defaultCostPriceYuan: (row.defaultCostPrice || 0) / 100 }
    : { status: "ENABLED", interfaceCode: "", callbackMode: 0, defaultPriceYuan: 0, defaultCostPriceYuan: 0 };
  productDialog.visible = true;
}

function openAuthDialog(row) {
  loadAppOptions();
  loadAuthProductOptions();
  loadInternalProductOptions();
  authDialog.form = row
    ? { ...row, internalProductId: row.internalProductId ? String(row.internalProductId) : null, salePriceYuan: (row.salePrice || 0) / 100, costPriceYuan: (row.costPrice || 0) / 100 }
    : { status: "ENABLED", callbackEnabled: 0, internalProductId: null, salePriceYuan: 0, costPriceYuan: 0, testLimit: 0, testUsedCount: 0 };
  authDialog.visible = true;
}


function removeProduct(row) {
  const name = row.productName || row.productCode;
  ElMessageBox.confirm(`确认删除产品“${name}”吗？如果该产品已有应用授权，系统会拒绝删除。`, "提示", { type: "warning" })
    .then(() => deleteOpenApiProduct({ id: row.id }))
    .then(() => {
      ElMessage.success("删除成功");
      loadProducts();
      loadAuthProductOptions();
    });
}
function saveProduct() {
  const data = {
    id: productDialog.form.id,
    productCode: productDialog.form.productCode,
    productName: productDialog.form.productName,
    productType: productDialog.form.productType,
    interfaceCode: productDialog.form.interfaceCode || productDialog.form.invokeCode,
    callbackMode: productDialog.form.callbackMode || 0,
    status: productDialog.form.status,
    defaultPrice: cent(productDialog.form.defaultPriceYuan),
    defaultCostPrice: cent(productDialog.form.defaultCostPriceYuan),
    remark: productDialog.form.remark,
  };
  state.fullLoading = true;
  saveOpenApiProduct(data).then(() => {
    ElMessage.success("保存成功");
    productDialog.visible = false;
    loadProducts();
  }).finally(() => state.fullLoading = false);
}


function removeAuth(row) {
  const name = row.productCode || row.id;
  ElMessageBox.confirm(`确认删除产品授权“${name}”吗？如果该授权已有有效订单，系统会拒绝删除。`, "提示", { type: "warning" })
    .then(() => deleteOpenApiAppProduct({ id: row.id }))
    .then(() => {
      ElMessage.success("删除成功");
      loadAuths();
    });
}
function saveAuth() {
  if (!authDialog.form.appId) {
    ElMessage.warning("请选择应用");
    return;
  }
  if (!authDialog.form.productCode) {
    ElMessage.warning("请选择开放产品");
    return;
  }
  if (!OPTIONAL_INTERNAL_PRODUCT_CODES.has(normalizeCode(authDialog.form.productCode)) && !authDialog.form.internalProductId) {
    ElMessage.warning("请选择要调用的内部产品");
    return;
  }
  const data = {
    id: authDialog.form.id,
    appId: authDialog.form.appId,
    merchantId: authDialog.form.merchantId,
    productCode: authDialog.form.productCode,
    internalProductId: authDialog.form.internalProductId || null,
    status: authDialog.form.status,
    salePrice: cent(authDialog.form.salePriceYuan),
    costPrice: cent(authDialog.form.costPriceYuan),
    dailyLimit: authDialog.form.dailyLimit,
    monthlyLimit: authDialog.form.monthlyLimit,
    testLimit: authDialog.form.testLimit,
    callbackEnabled: authDialog.form.callbackEnabled,
    callbackUrl: authDialog.form.callbackUrl,
  };
  state.fullLoading = true;
  saveOpenApiAppProduct(data).then(() => {
    ElMessage.success("保存成功");
    authDialog.visible = false;
    loadAuths();
  }).finally(() => state.fullLoading = false);
}

function parseTemplateRemark(remark) {
  try { return remark ? JSON.parse(remark) : {}; } catch (e) { return {}; }
}

function loadProductTemplateFallback() {
  return getOpenApiProductPage({ status: "ENABLED", current: 1, size: 1000 }).then((res) => {
    productTemplates.value = (res.data?.records || []).map((item) => ({ productCode: item.productCode, productName: item.productName, productType: item.productType, interfaceCode: item.interfaceCode || item.invokeCode, invokeCode: item.invokeCode, callbackMode: item.callbackMode || 0, defaultPrice: item.defaultPrice, defaultCostPrice: item.defaultCostPrice }));
  });
}

function loadProductTemplates() {
  return getDictItemPageFun({ dictCode: PRODUCT_TEMPLATE_DICT, status: 1, current: 1, size: 1000 }).then((res) => {
    productTemplates.value = (res.data?.records || []).map((item) => ({ productCode: item.itemCode, productName: item.itemName, ...parseTemplateRemark(item.remark) }));
    if (!productTemplates.value.length) return loadProductTemplateFallback();
  }).catch(() => loadProductTemplateFallback());
}

function loadAppOptions() {
  return getOpenApiAppPage({ status: "ENABLED", current: 1, size: 1000 }).then((res) => { appOptions.value = res.data.records || []; });
}

function loadAuthProductOptions() {
  return getOpenApiProductPage({ status: "ENABLED", current: 1, size: 1000 }).then((res) => { authProductOptions.value = res.data.records || []; });
}

function loadInternalProductOptions() {
  return getProductListFun({ status: 1, current: 1, size: 1000 }).then((res) => { internalProducts.value = res.data?.records || []; });
}

function applyProductTemplate(productCode) {
  const item = productTemplates.value.find((template) => template.productCode === productCode);
  if (!item) return;
  productDialog.form.productName = item.productName;
  productDialog.form.productType = item.productType || "ACCIDENT";
  productDialog.form.interfaceCode = item.interfaceCode || item.invokeCode || item.productCode;
  productDialog.form.invokeCode = item.invokeCode || item.interfaceCode || item.productCode;
  productDialog.form.callbackMode = item.callbackMode || 0;
  if (item.defaultPrice !== undefined) productDialog.form.defaultPriceYuan = Number(item.defaultPrice || 0) / 100;
  if (item.defaultCostPrice !== undefined) productDialog.form.defaultCostPriceYuan = Number(item.defaultCostPrice || 0) / 100;
}

function applyAuthApp(appId) {
  const item = appOptions.value.find((app) => String(app.id) === String(appId));
  if (!item) return;
  authDialog.form.merchantId = item.merchantId;
}

function applyAuthProduct(productCode) {
  const item = authProductOptions.value.find((product) => product.productCode === productCode);
  if (!item) return;
  authDialog.form.salePriceYuan = Number(item.defaultPrice || 0) / 100;
  authDialog.form.costPriceYuan = Number(item.defaultCostPrice || 0) / 100;
  const currentId = authDialog.form.internalProductId;
  if (currentId && !filteredInternalProducts.value.some((product) => String(product.productId) === String(currentId))) {
    authDialog.form.internalProductId = null;
  }
}

onMounted(() => {
  loadProducts();
  loadProductTemplates();
  loadAuthProductOptions();
  loadInternalProductOptions();
});
</script>

<style lang="scss" scoped>
.openapi-page { padding: 16px; }
.page-header { font-weight: 600; }
.toolbar { display: flex; gap: 10px; margin-bottom: 12px; flex-wrap: wrap; }
.toolbar .el-input, .toolbar .el-select { width: 190px; }
.pagination-box { margin-top: 14px; display: flex; justify-content: flex-end; }
.form-tip { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1; }
</style>
